import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../../api.js'
import { Card, Field, Alert, UserSearch } from '../../lib.jsx'

const STATUS_PL = { draft: 'roboczy', composed: 'złożony', published: 'opublikowany' }

export default function Projects() {
  const nav = useNavigate()
  const [projects, setProjects] = useState([])
  const [templates, setTemplates] = useState([])
  const [picked, setPicked] = useState(null)
  const [templateId, setTemplateId] = useState('')
  const [name, setName] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  const load = () => api.adminProjects().then(setProjects).catch(e => setErr(e.message))
  useEffect(() => {
    load()
    api.templates().then(ts => setTemplates(ts.filter(t => t.status === 'published'))).catch(() => {})
  }, [])

  const create = async (e) => {
    e.preventDefault()
    if (!picked || !templateId) return
    setBusy(true); setErr('')
    try {
      await api.createProject({ name: name || 'Nowy projekt', template_id: templateId, owner_user_id: picked.id })
      setPicked(null); setTemplateId(''); setName('')
      load()
    } catch (e) { setErr(e.message) } finally { setBusy(false) }
  }

  const remove = async (p) => {
    if (!window.confirm(`Usunąć projekt „${p.name}” użytkownika ${p.owner_username} bezpowrotnie?`)) return
    try { await api.deleteProject(p.id); load() } catch (e) { setErr(e.message) }
  }

  return (
    <>
      <div className="topbar">
        <div><h1>Ebooki / broszury użytkowników</h1>
          <div className="sub">Wgląd i zarządzanie ebookami, broszurami i ofertami PDF wszystkich użytkowników.</div></div>
      </div>
      <div className="content grid grid-2" style={{ alignItems: 'start' }}>
        <Card title="Nowy projekt dla użytkownika">
          <Alert kind="err">{err}</Alert>
          {templates.length === 0 ? (
            <div className="empty">Brak opublikowanych szablonów.</div>
          ) : (
            <form onSubmit={create}>
              <Field label="Użytkownik (właściciel)">
                {picked ? (
                  <div className="unit-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span><b>{picked.username}</b> <span className="muted small">{picked.email}</span></span>
                    <button type="button" className="btn btn-sm btn-ghost" onClick={() => setPicked(null)}>Zmień</button>
                  </div>
                ) : <UserSearch onPick={setPicked} />}
              </Field>
              <Field label="Nazwa projektu">
                <input value={name} onChange={e => setName(e.target.value)} placeholder="np. Raport Q1 2026" />
              </Field>
              <Field label="Szablon">
                <select value={templateId} onChange={e => setTemplateId(e.target.value)}>
                  <option value="">— wybierz szablon —</option>
                  {templates.map(t => <option key={t.id} value={t.id}>{t.name} ({t.document_type}, {t.page_size})</option>)}
                </select>
              </Field>
              <button className="btn btn-primary" disabled={busy || !picked || !templateId}>
                {busy ? 'Tworzenie…' : 'Utwórz projekt'}
              </button>
            </form>
          )}
        </Card>

        <Card title="Wszystkie ebooki / broszury" desc={`${projects.length} łącznie`}>
          {projects.length === 0 ? <div className="empty">Brak projektów w systemie.</div> : (
            <table>
              <thead><tr><th>Nazwa</th><th>Właściciel</th><th>Szablon</th><th>Status</th><th /></tr></thead>
              <tbody>
                {projects.map(p => (
                  <tr key={p.id}>
                    <td><a onClick={() => nav(`/projects/${p.id}`)} style={{ cursor: 'pointer', fontWeight: 700 }}>{p.name || '(bez nazwy)'}</a>
                      <div className="muted small">{new Date(p.updated_at).toLocaleString('pl-PL')}</div></td>
                    <td>{p.owner_username}</td>
                    <td className="small">{p.template_name}</td>
                    <td><span className="pill">{STATUS_PL[p.status] || p.status}</span></td>
                    <td><button className="btn btn-sm btn-danger" onClick={() => remove(p)}>Usuń</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Card>
      </div>
    </>
  )
}
